"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_ctv_framework_main_1 = require("@sky-uk-ott/client-lib-js-ctv-framework-main");
var subtitles_1 = require("./subtitles");
var SUCCESSIVE_PLAYOUT_TOLERANCE = 250;
var CommonPlayerComponent = (function (_super) {
    __extends(CommonPlayerComponent, _super);
    function CommonPlayerComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.lastPlayoutRequestStartTime = new Date(0).getTime();
        _this.saveVideoWrapperElementRef = function (elementRef) {
            _this.videoWrapperElementRef = elementRef;
        };
        _this.adaptPlayoutRequest = function (playoutRequest) {
            if (!playoutRequest || 'id' in playoutRequest || playoutRequest.playoutRect) {
                return playoutRequest;
            }
            return __assign({}, playoutRequest, { videoHTMLContainerInfo: {
                    videoHTMLContainer: _this.videoWrapperElementRef,
                } });
        };
        _this.setFullScreen = function () {
            if (_this.lifecycle) {
                _this.lifecycle.setFullscreen(true);
            }
        };
        _this.exitFullScreen = function () {
            if (_this.lifecycle) {
                _this.lifecycle.setFullscreen(false);
            }
        };
        _this.player = client_lib_js_ctv_framework_main_1.Core.getDevice().player;
        _this.lifecycle = client_lib_js_ctv_framework_main_1.Core.getDevice().lifecycle;
        _this.state = {
            subtitlesText: [],
        };
        var factory = client_lib_js_ctv_framework_main_1.Core.getDeviceFactory();
        _this.checkForCustomPropsChanges = function (previousCustomProps, nextCustomProps) {
            return factory.checkForCustomPropsChanges && factory.checkForCustomPropsChanges(previousCustomProps, nextCustomProps);
        };
        _this.logger = client_lib_js_player_addons_common_player_1.defaultLogger.withContext('CPC');
        return _this;
    }
    CommonPlayerComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.player.onSubtitlesTextChanged(function (textItems) {
            _this.setState({ subtitlesText: textItems });
        }, this);
        this.mapCallbacks();
        this.checkForChanges(CommonPlayerComponent.defaultProps, this.props);
        if (this.lifecycle) {
            this.lifecycle.onFullscreenChanged(this.props.onFullscreenChanged);
        }
    };
    CommonPlayerComponent.prototype.componentWillUnmount = function () {
        this.player.removeEventListeners(this);
        this.player = undefined;
    };
    CommonPlayerComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.checkForChanges(this.props, nextProps);
    };
    CommonPlayerComponent.prototype.render = function () {
        return (React.createElement("div", { style: this.props.style, ref: this.saveVideoWrapperElementRef },
            React.createElement(subtitles_1.Subtitles, { className: this.props.subtitlesClassName, textItems: this.state.subtitlesText }),
            this.props.children));
    };
    CommonPlayerComponent.prototype.isPlayerActive = function () {
        return this.player.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Stopped && this.player.currentState !== client_lib_js_player_addons_common_player_1.PlayerState.Loading && this.player.isSessionActive;
    };
    CommonPlayerComponent.prototype.checkForChanges = function (previousProps, nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            var nextPlayoutRequest, previousCustomProps, nextCustomProps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(nextProps.playoutRequest && nextProps.playoutRequest !== previousProps.playoutRequest)) return [3, 4];
                        this.logErrorOnSuccessivePlayoutRequests();
                        nextPlayoutRequest = this.adaptPlayoutRequest(nextProps.playoutRequest);
                        if (!this.player.isSessionActive) return [3, 2];
                        return [4, this.player.endSession()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4, this.player.startSession(nextPlayoutRequest)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (nextProps.fullscreen && !previousProps.fullscreen) {
                            this.setFullScreen();
                        }
                        else if (!nextProps.fullscreen && previousProps.fullscreen) {
                            this.exitFullScreen();
                        }
                        if (this.player.isSessionActive && nextProps.play && nextProps.play !== previousProps.play) {
                            if (nextProps.play.value === true) {
                                if (this.player.currentState === client_lib_js_player_addons_common_player_1.PlayerState.Paused) {
                                    this.player.play();
                                }
                            }
                            else if (this.player.currentState === client_lib_js_player_addons_common_player_1.PlayerState.Playing ||
                                this.player.currentState === client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering ||
                                this.player.currentState === client_lib_js_player_addons_common_player_1.PlayerState.Seeking) {
                                this.player.pause();
                            }
                        }
                        if (this.player.isSessionActive && nextProps.stop && nextProps.stop !== previousProps.stop && nextProps.stop.value) {
                            this.player.endSession();
                        }
                        if (this.player.isSessionActive && nextProps.position && nextProps.position !== previousProps.position) {
                            this.player.seek(nextProps.position.value);
                        }
                        if (this.isPlayerActive() && nextProps.mute && nextProps.mute !== previousProps.mute) {
                            this.player.setMute(nextProps.mute.value);
                        }
                        if (this.isPlayerActive() && nextProps.volume && nextProps.volume !== previousProps.volume) {
                            this.player.setVolume(nextProps.volume.value);
                        }
                        if (this.isPlayerActive() && nextProps.abrConfig && nextProps.abrConfig !== previousProps.abrConfig) {
                            this.player.setAbrConfig(nextProps.abrConfig);
                        }
                        if (nextProps.adProfileLimits && nextProps.adProfileLimits !== previousProps.adProfileLimits) {
                            this.player.updateAdProfileLimits(nextProps.adProfileLimits);
                        }
                        if (this.isPlayerActive() &&
                            nextProps.selectedAudioTrack.value &&
                            nextProps.selectedAudioTrack !== previousProps.selectedAudioTrack &&
                            nextProps.selectedAudioTrack.value !== previousProps.selectedAudioTrack.value) {
                            this.player.setAudioTrack(nextProps.selectedAudioTrack.value);
                        }
                        if (nextProps.selectedSubtitlesTrack !== previousProps.selectedSubtitlesTrack &&
                            nextProps.selectedSubtitlesTrack.value !== previousProps.selectedSubtitlesTrack.value) {
                            if (nextProps.selectedSubtitlesTrack.value) {
                                this.player.enableSubtitles(nextProps.selectedSubtitlesTrack.value);
                            }
                            else {
                                this.player.disableSubtitles();
                            }
                        }
                        if (nextProps.skipAdBreak && nextProps.skipAdBreak !== previousProps.skipAdBreak) {
                            this.player.skipCurrentAdBreak();
                        }
                        previousCustomProps = previousProps && previousProps.custom;
                        nextCustomProps = nextProps && nextProps.custom;
                        this.checkForCustomPropsChanges(previousCustomProps, nextCustomProps);
                        return [2];
                }
            });
        });
    };
    CommonPlayerComponent.prototype.logErrorOnSuccessivePlayoutRequests = function () {
        if (Date.now() - this.lastPlayoutRequestStartTime < SUCCESSIVE_PLAYOUT_TOLERANCE) {
            this.logger.error('CPC-1000', {
                message: 'Attempted to start multiple playout sessions in quick succession. This is likely to be an integration issue with the common player component. Please ensure you are only setting playoutRequest props once per session.',
            });
        }
        this.lastPlayoutRequestStartTime = Date.now();
    };
    CommonPlayerComponent.prototype.mapCallbacks = function () {
        var _this = this;
        this.player.onStateChanged(function (state) {
            if (_this.props.onStateChanged) {
                _this.props.onStateChanged(state);
            }
        }, this);
        this.player.onStopped(function () {
            if (_this.props.onStopped) {
                _this.props.onStopped();
            }
        }, this);
        this.player.onLoading(function () {
            if (_this.props.onLoading) {
                _this.props.onLoading();
            }
        }, this);
        this.player.onPlaying(function () {
            if (_this.props.onPlaying) {
                _this.props.onPlaying();
            }
        }, this);
        this.player.onPaused(function () {
            if (_this.props.onPaused) {
                _this.props.onPaused();
            }
        }, this);
        this.player.onRebuffering(function () {
            if (_this.props.onRebuffering) {
                _this.props.onRebuffering();
            }
        }, this);
        this.player.onSeeking(function () {
            if (_this.props.onSeeking) {
                _this.props.onSeeking();
            }
        }, this);
        this.player.onFinished(function () {
            if (_this.props.onFinished) {
                _this.props.onFinished();
            }
        }, this);
        this.player.onBitrateChange(function (bitrate) {
            if (_this.props.onBitrateChange) {
                _this.props.onBitrateChange(bitrate);
            }
        }, this);
        this.player.onCurrentPositionChanged(function (position) {
            if (_this.props.onCurrentPositionChanged) {
                _this.props.onCurrentPositionChanged(position);
            }
        }, this);
        this.player.onDurationChanged(function (duration) {
            if (_this.props.onDurationChanged) {
                _this.props.onDurationChanged(duration);
            }
        }, this);
        this.player.onError(function (error) {
            if (_this.props.onError) {
                _this.props.onError(error);
            }
        }, this);
        this.player.onWarning(function (error) {
            if (_this.props.onWarning) {
                _this.props.onWarning(error);
            }
        }, this);
        this.player.onAvailableAudioTracksChanged(function (tracks) {
            if (_this.props.onAvailableAudioTracksChanged) {
                _this.props.onAvailableAudioTracksChanged(tracks);
            }
        }, this);
        this.player.onCurrentAudioTrackChanged(function (track) {
            if (_this.props.onCurrentAudioTrackChanged) {
                _this.props.onCurrentAudioTrackChanged(track);
            }
        }, this);
        this.player.onAvailableSubtitlesTracksChanged(function (tracks) {
            if (_this.props.onAvailableSubtitlesTracksChanged) {
                _this.props.onAvailableSubtitlesTracksChanged(tracks);
            }
        }, this);
        this.player.onCurrentSubtitlesTrackChanged(function (track) {
            if (_this.props.onCurrentSubtitlesTrackChanged) {
                _this.props.onCurrentSubtitlesTrackChanged(track);
            }
        }, this);
        this.player.onSessionStarted(function () {
            if (_this.props.onSessionStarted) {
                _this.props.onSessionStarted();
            }
        }, this);
        this.player.onSessionEnded(function () {
            if (_this.props.onSessionEnded) {
                _this.props.onSessionEnded();
            }
        }, this);
        this.player.onAdBreakStarted(function (adBreakData) {
            if (_this.props.onAdBreakStarted) {
                _this.props.onAdBreakStarted(adBreakData);
            }
        }, this);
        this.player.onAdBreakFinished(function (adBreakData) {
            if (_this.props.onAdBreakFinished) {
                _this.props.onAdBreakFinished(adBreakData);
            }
        }, this);
        this.player.onAdStarted(function (adStartedData) {
            if (_this.props.onAdStarted) {
                _this.props.onAdStarted(adStartedData);
            }
        }, this);
        this.player.onAdFinished(function (adFinishedData) {
            if (_this.props.onAdFinished) {
                _this.props.onAdFinished(adFinishedData);
            }
        }, this);
        this.player.onAdError(function (adErrorData) {
            if (_this.props.onAdError) {
                _this.props.onAdError(adErrorData);
            }
        }, this);
    };
    CommonPlayerComponent.defaultProps = {
        selectedAudioTrack: { value: undefined },
        selectedSubtitlesTrack: { value: undefined },
    };
    return CommonPlayerComponent;
}(React.Component));
exports.CommonPlayerComponent = CommonPlayerComponent;
